import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_XIAOCHENGBEN_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_157',  // 电影/小成本电影·版本二
        name: '一层地下',
        genre: 'movie',
        synopsis: '一座老商场要改建成夜市，为赶开业在夜里无证施工。夜巡看守罗来福被塌下来的建材封进地下二层的电梯井，身边只有一部对讲机和一台剩百分之十二电的手机，而地面上庆功宴正一场接一场敬酒。对讲机那头从没人信、到有人推辞、再到有人肯来，条件是他在井底亲口承认自己这个夜班是违规顶来的——话一落地，吊车才下来，他也要为这张加班单担下责任。',
        roles: [
            {
                name: '罗来福',
                roleType: '男主角',
                billing: 1,
                intro: '商场的夜巡看守，顶的是别人辞掉的夜班。他在井底把对讲机按了一遍又一遍，头半小时讲规程，后半段开始讲家里的事。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '邝小梅',
                roleType: '女配角',
                billing: 2,
                intro: '商场的会计，庆功宴上唯一肯去配电间查跳闸的人。她手里那张外包用工表一直没签字。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '韦家树',
                roleType: '男配角',
                billing: 3,
                intro: '商场的夜班电工，对讲机另一头的声音就是他。那张加班单他签过字。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 3, talent: 2 },
            },
            {
                name: '送酒司机',
                roleType: '男配角',
                billing: 5,
                intro: '给庆功宴送酒的司机，车停在后门，收货签字的人一直没下来。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.SeriousDrama],
        heat: 50,
        baseScore: 7.9,
        // 四番空一格（文档即无四番卡），按"番位空缺可接受"不补。
    },
    {
        id: 'SCRIPT_158',  // 电影/小成本电影·版本三
        name: '欠条',
        genre: 'movie',
        synopsis: '一家信用社要并入县行，搬迁前最后一天清账。规矩是：还清了、本人来签字，条子当场作废退人；没结清的一张也不能外流。这天来的三个人各为一张条子——车队老板傅广运欠三万，当天要还清并拿走作废的那张；替人讨债的乔七想弄走几张没结清的，凭条子去收钱；廖青娣只想把丈夫留下的那张两千块要回来。傍晚停电，第二天一早抽屉开了，少了三张——头一天进过这间屋子的四个人都有机会。',
        roles: [
            {
                name: '何秋菊',
                roleType: '女主角',
                billing: 1,
                intro: '信用社柜员，在这扇柜台坐了九年。她的规矩是还清了、本人来签字，条子才作废退人，行长催着清库存她也不松手。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { wisdom: 3, talent: 3, temperament: 2 },
            },
            {
                name: '傅广运',
                roleType: '男配角',
                billing: 2,
                intro: '车队老板，包着周边工地的建材运输，欠信用社三万。利息他一概不认，当天要把本金还清、把条子拿回去。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '乔七',
                roleType: '男配角',
                billing: 3,
                intro: '替人讨债的年轻人，跟过傅广运的车队，也在别人的欠条上按过手印。条子在谁手里，谁就能去要那笔钱。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 3, talent: 2 },
            },
            {
                name: '廖青娣',
                roleType: '女配角',
                billing: 4,
                intro: '丈夫留下的两千块账，她今天来还清、把押在信用社的那张条子要回去。她只带了一本自家记的流水账。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
            {
                name: '摩托载客仔',
                roleType: '男配角',
                billing: 5,
                intro: '信用社门口等活的摩的司机，谁给钱拉谁，这一天他把车上那四位的活都拉了。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Crime, ScriptTheme.Comedy, ScriptTheme.LifeStyle],
        heat: 48,
        baseScore: 7.5,
    },
    {
        id: 'SCRIPT_159',  // 电影/小成本电影·版本四
        name: '清场',
        genre: 'movie',
        synopsis: '韩师傅去世了，儿子韩志远从长途线上把车开回来奔丧。殡仪馆化妆房里等着替老人修面的，是他处了十一年的男朋友裴卫东——馆里的规矩是化妆师不进灵堂，这一夜两人只在化妆间和走廊里碰面。第二天要贴讣告，母亲坚持把裴卫东的名字也写上去，可称谓栏只有儿子、儿媳、孙子那些称谓，没有一个词汇装得下这个人。',
        roles: [
            {
                name: '裴卫东',
                roleType: '男主角',
                billing: 1,
                intro: '殡仪馆的遗体化妆师，馆里都说他修的面最稳。父母走得早，家里就剩他一个人。韩志远常年在外跑长途，儿子的责任裴卫东替他尽了十一年。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '韩志远',
                roleType: '男二号',
                billing: 2,
                intro: '跑长途线的货运司机，一年回来两次。这回他把车从省外一路开回来，人还没落座就去车队结了那趟的过路单；要用的证明揣了一沓，照旧递给裴卫东，由他去跟馆里的手续打交道。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, stamina: 2, wisdom: 2 },
            },
            {
                name: '韩晓雪',
                roleType: '女配角',
                billing: 3,
                intro: '逝者的小女儿，韩志远的妹妹，在小学代课。她赶到时丧事已办了一半，提的要求就一条：讣告别改。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '谭国平',
                roleType: '男配角',
                billing: 4,
                intro: '殡仪馆的车管兼守门，深夜进出馆的车都经他登记。他不进灵堂，在门口抽烟等人天亮。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { wisdom: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Romance],
        heat: 54,
        baseScore: 8.2,
        // 全片无女主角位（男性同性情感题材），女角色只有三番韩晓雪——按"特殊剧可缺位"保留。
    },
    {
        id: 'SCRIPT_160',  // 电影/小成本电影·版本五
        name: '抢麦',
        genre: 'movie',
        synopsis: '小酒馆每月办一次拼盘夜，这次轮到她们，只给半小时，台上只有一支麦。谁站中间谁拿那支麦，成了问题。歌是吉他手黎笙写的，低音线却是贝斯手何漾编的，两人谁都不服谁，偏偏又各自疑心对方暗恋鼓手邱南——为了气对方，也为了把人抢到自己这边来，都跑去跟他献殷勤。',
        roles: [
            {
                name: '黎笙',
                roleType: '女主角',
                billing: 1,
                intro: '队里的主音吉他手，写谱、调琴、跟场地方谈时段都归她。她说中间那支麦是留给唱歌的人的，说完自己也没站上去。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'artistry', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { artistry: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '何漾',
                roleType: '女主角',
                billing: 1,
                intro: '进队半年的贝斯手，弹的是全场最不被听见的低音，她说这样最好，弹错也听不出来。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'artistry', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { artistry: 3, stamina: 3, wisdom: 2 },
            },
            {
                name: '邱南',
                roleType: '男配角',
                billing: 2,
                intro: '鼓手，队里唯一有固定工资的人，白天在琴行上班。两个人各自说给他的那些话，他一句也没接，只在鼓上回了一段。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'artistry', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { artistry: 2, stamina: 2, wisdom: 2 },
            },
            {
                name: '詹予同',
                roleType: '女配角',
                billing: 3,
                intro: '小酒馆的演出统筹，每月拼盘夜谁先上、谁几点下，由她在纸上一格一格写。她只管把时段切给乐队，那支麦归谁，留给她们自己争。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'wisdom', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { wisdom: 3, temperament: 2 },
            },
            {
                name: '琴行学徒',
                roleType: '男配角',
                billing: 5,
                intro: '邱南白天上班那家琴行的学徒，周六跟来帮乐队搬音箱、接线、试话筒.',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'artistry', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { artistry: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Romance, ScriptTheme.Music],
        heat: 48,
        baseScore: 7.2,
        // 双女主并列一番（两人 billing 均 1）：群像门槛 2026-10-02 已改为"同一性别主角并列 ≥3"，
        // 双女主不算群像 ⇒ ⛔ 压二番，走 `docs/剧本/文案编写方法.md` §四之二 非群像判例。四番空一格。
    },
    {
        id: 'SCRIPT_161',  // 电影/小成本电影·版本六
        name: '旅馆与海',
        genre: 'movie',
        synopsis: '南方渔港，旅馆老板娘周海珠有个老客人沈若沅，每月来住三天，来了二十年。沈若沅的丈夫二十年前出海没回来，她每天傍晚去堤上看海，每月托港上的修船工阿晃买一张返程船票，留着给那个人回家用。那一年出海的船上，活着回来的只有周海珠的丈夫一个。这一趟，沈若沅把二十年攒下的船票摊在柜台上数了一遍，要坐船走一遍那条航线。周海珠当天把旅馆的钥匙交给帮工，收拾了一只行李袋，陪她一起走。',
        roles: [
            {
                name: '周海珠',
                roleType: '女主角',
                billing: 1,
                intro: '渔港边一家小旅馆的老板娘，丈夫常年跑船，十六间房归她一个人管。她收留那个女客，起因是欠她一顿饭。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { temperament: 3, talent: 3, charm: 2 },
            },
            {
                name: '沈若沅',
                roleType: '女二号',
                billing: 2,
                intro: '每月来住三天的女客，在等一个出海没回来的人。随身一只旧木匣，里面是她历年攒下的返程船票，住的那间靠海，不许人动。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '阿晃',
                roleType: '男配角',
                billing: 3,
                intro: '渔港上的修船工，老板娘丈夫的表弟。女客每次来都托他代买一张返程船票，哪一天买、哪一班船，他记得比女客自己清楚。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 3, talent: 2 },
            },
            {
                name: '旅馆帮工',
                roleType: '男配角',
                billing: 5,
                intro: '旅馆前台的帮工，搬行李、烧热水，老板娘出门那几天由他看着柜台。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Mystery, ScriptTheme.Romance, ScriptTheme.LifeStyle],
        heat: 29,
        // 低分反面教材（本档自创、无范本）：baseScore 4.3 是设定值而非笔误，heat 按 §1 公式派生。
        baseScore: 4.3,
    },
    {
        id: 'SCRIPT_162',  // 电影/小成本电影·版本六（2026-10-06 新增，填 SCRIPT_156 无此镇提级后的 Y4Q4 第 3 槽）
        name: '标准音',
        genre: 'movie',
        synopsis: '琴行调音师顾聆接了一单活：城郊贺宅一架老钢琴，婚宴上要用，婚期三周，她每周上门一次。雇主的女儿温荔要在婚宴上弹一曲，那架琴是母亲的陪嫁，她十年没碰过。顾聆一周来一次，每次调一个八度；温荔坐在旁边听，后来也开始弹。琴越来越准，有些没说出口的事也越来越清楚。最后一次调音，两个人都明白这单活到头了。',
        roles: [
            {
                name: '顾聆',
                roleType: '女主角',
                billing: 1,
                intro: '琴行的调音师，话少，耳朵极尖，按次收费调完就走。这单三周，是她接过的最长的一单活。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'artistry', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { temperament: 3, talent: 3, artistry: 2 },
            },
            {
                name: '温荔',
                roleType: '女二号',
                billing: 2,
                intro: '贺家的独女，婚事是家里定好的。婚宴上要弹的那架琴是母亲的陪嫁，她十岁以后没再碰过。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'charm', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, charm: 2, temperament: 2 },
            },
            // 三番·贺太太（45 岁）超龄，按导入台账规则 8 不导入代码，番位空一格不补（文档保留角色卡）。
            {
                name: '郑合',
                roleType: '男配角',
                billing: 4,
                intro: '琴行老板，这单大活是他接的，分给顾聆跑。他不知道这单活计三周，比过去一年加起来都长。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { wisdom: 2, charm: 2 },
            },
            {
                name: '搬琴工人',
                roleType: '男配角',
                billing: 5,
                intro: '婚庆公司雇来搬琴的。琴从客厅挪去花园那天，他听见里头弹琴的人换了。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.Music],
        heat: 54,
        baseScore: 7.8,
    },
    {
        // 特殊剧本（高口碑型，2026-10-06 由本档原 SCRIPT_156 提级；内容恢复原导入数据，数值暂定待茄子手调）
        // 附表见 tables/SpecialScripts.ts
        id: 'SCRIPT_903',
        name: '无此镇',
        genre: 'movie',
        synopsis: '中学天文社每周五晚在活动室整理观测记录。这天晚上，高一社员叶栖迟到两个多小时，回来说自己坐错了班车，到了一个地图上查不到的镇子。她掏出一张镇口小卖部的收据，日期印的是下周六——那天还没有到。带队老师伍春禾本已通知家长来领人，认定她是逃课出去玩，看完这张收据却不问了，转而带着另外三个学生翻地图、给那个镇打电话，一直忙到天亮。',
        roles: [
            {
                name: '伍春禾',
                roleType: '女主角',
                billing: 1,
                intro: '中学的地理老师，天文社的带队人。观测记录本由她签字，谁写错一行她用红笔圈出来。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '叶栖',
                roleType: '女二号',
                billing: 2,
                intro: '高一学生，社里唯一敢夜里翻校门出去看流星的人。她讲那趟坐错的班车，细节一遍和一遍完全对得上，讲完把收据放在桌上。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '韩冬青',
                roleType: '男配角',
                billing: 3,
                intro: '天文社社长，借钥匙、记出勤归他管。那一晚给那个镇打电话的是他，前后打了三次。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 30 },
                    { attr: 'stamina', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { wisdom: 3, stamina: 2 },
            },
            {
                name: '陈择',
                roleType: '男配角',
                billing: 4,
                intro: '高三组员，家里卖气象器材。地图是从他家搬来的，气象报文也是他查的。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 18 },
                    { attr: 'artistry', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { wisdom: 2, artistry: 2 },
            },
            {
                name: '校门口保安',
                roleType: '男配角',
                billing: 5,
                intro: '夜里那扇铁丝门归他开。他记得这个学生十点四十回来，也记得她鞋底是干的。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Mystery],
        heat: 60,
        baseScore: 8.4,
    },
];
